<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'予約設問：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'予約設問：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addQuestion()" [disabled]="!questionFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form" [formGroup]="questionFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">

        <div>
          <span>{{'■基本情報' | translate}}</span>
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="25%">
              <mat-label floatLabel="always">ID</mat-label>
              <input matInput *ngIf="!isAdded" placeholder="ID" id="questionId" formControlName="questionId" readonly>
              <input matInput *ngIf="!!isAdded" placeholder="ID" id="questionId" formControlName="questionId">
              <mat-error *ngIf="questionIdControl.invalid">{{ getErrorMessageToQuestionId() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="25%">
              <mat-label floatLabel="always">{{'表示番号' | translate}}</mat-label>
              <input type="number" matInput placeholder="{{'表示番号' | translate}}" id="displayNo"
                formControlName="displayNo">
              <mat-error *ngIf="displayNoControl.invalid">{{ getErrorMessageTodisplayNo() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'設問タイプ' | translate}}</mat-label>
              <mat-select placeholder="{{'設問タイプ' | translate}}" id="questionType" formControlName="questionType"
                (selectionChange)="onQuestionTypeChange($event)">
                <mat-option *ngFor="let questionType of questionTypes" [value]="questionType">
                  {{ questionType }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex>
              <mat-label floatLabel="always">{{'設問' | translate}}</mat-label>
              <input matInput placeholder="{{'設問' | translate}}" id="questionNames"
                value="{{ question!.question_names | multiQname:projectLanguages:projectBaseLang }}" readonly>
              <button matSuffix mat-stroked-button color="primary" (click)="openQuestionNameDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="questionNamesControl.invalid">{{ getErrorMessageToQuestionName() }}</mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex>
              <mat-label floatLabel="always">{{'補足文章' | translate}}</mat-label>
              <textarea matInput placeholder="{{'補足文章' | translate}}" id="questionComps" rows="3"
                value="{{ question!.question_comps | multiQcomp:projectLanguages:projectBaseLang }}" readonly></textarea>
              <button matSuffix mat-stroked-button color="primary" (click)="openQuestionCompDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="questionCompsControl.invalid">{{ getErrorMessageToQuestionComp() }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div
          *ngIf="questionTypeControl.value === 'select' || questionTypeControl.value === 'checkbox' || questionTypeControl.value === 'radio'">
          <div fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'■選択肢' | translate}}</span>
            <button mat-stroked-button (click)="appendClick()">
              <mat-icon>add</mat-icon>
              <span>{{'選択肢追加' | translate}}</span>
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>{{'選択肢' | translate}}</th>
                <th width="70px"></th>
                <th width="200px">{{'値' | translate}}</th>
                <th width="70px">{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropSelectItem($event)">
              <tr *ngFor="let question_select_item of question!.question_select_items!; let i = index" cdkDrag
                cdkDragLockAxis="y">
                <td>
                  <mat-form-field fxFlexFill floatLabel="always">
                    <input matInput value="{{ question_select_item.items | multiQitem:projectLanguages:projectBaseLang }}"
                      required readonly>
                  </mat-form-field>
                </td>
                <td width="70px" style="overflow: auto;">
                  <button matSuffix mat-stroked-button color="primary" (click)="openQuestionItemDialog(i)">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
                <td width="200px">
                  <mat-form-field fxFlexFill floatLabel="always">
                    <input matInput value="{{ question_select_item.value }}" (change)="onSelectValueChange($event, i)"
                      required>
                  </mat-form-field>
                </td>
                <td width="70px" style="overflow: auto;">
                  <button mat-stroked-button color="warn" (click)="deleteClick(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

        <div>
          <span>{{'■チェック項目' | translate}}</span>
          <div fxLayout="row wrap" fxFlexFill fxLayoutAlign="start stretch" fxLayout.lt-sm="column" fxLayoutGap="20px">
            <p><mat-checkbox id="itemCheck01" formControlName="itemCheck01" color="primary">{{'必須' |
                translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck02" formControlName="itemCheck02" color="primary">{{'数値' |
                translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck03" formControlName="itemCheck03" color="primary"
                (change)="checkToggle('03', $event)">{{'半角英数' | translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck04" formControlName="itemCheck04" color="primary"
                (change)="checkToggle('04', $event)">{{'全角' | translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck05" formControlName="itemCheck05" color="primary"
                (change)="checkToggle('05', $event)">{{'全角カナ' | translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck06" formControlName="itemCheck06" color="primary"
                (change)="checkToggle('06', $event)">{{'全角かな' | translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck07" formControlName="itemCheck07" color="primary"
                (change)="checkToggle('07', $event)">{{'メールアドレス' | translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck08" formControlName="itemCheck08" color="primary"
                (change)="checkToggle('08', $event)">URL</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck09" formControlName="itemCheck09" color="primary"
                (change)="checkToggle('09', $event)">{{'電話番号' | translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck10" formControlName="itemCheck10" color="primary">{{'範囲' |
                translate}}</mat-checkbox></p>
            <p><mat-checkbox id="itemCheck11" formControlName="itemCheck11" color="primary">{{'文字数' |
                translate}}</mat-checkbox></p>
          </div>
        </div>

        <div *ngIf="!!itemCheck10Control.value">

          <div fxLayout="row" fxFlexFill fxLayoutAlign="start stretch" fxLayout.lt-sm="column" fxLayoutGap="20px"
            *ngIf="questionTypeControl.value === 'number'">
            <mat-form-field floatLabel="always" fxFlex="50%">
              <mat-label>{{'範囲チェック（下限）' | translate}}</mat-label>
              <input type="number" matInput placeholder="{{'範囲チェック（下限）' | translate}}" id="itemCheckRangeLower"
                formControlName="itemCheckRangeLower">
              <mat-error *ngIf="itemCheckRangeLowerControl.invalid">{{'範囲指定に誤りがあります' | translate}}</mat-error>
            </mat-form-field>
            <mat-form-field floatLabel="always" fxFlex="50%">
              <mat-label>{{'範囲チェック（上限）' | translate}}</mat-label>
              <input type="number" matInput placeholder="{{'範囲チェック（上限）' | translate}}" id="itemCheckRangeUpper"
                formControlName="itemCheckRangeUpper">
            </mat-form-field>
          </div>

          <div *ngIf="questionTypeControl.value === 'date'">

            <div fxLayout="row" fxFlexFill fxLayoutAlign="start stretch" fxLayout.lt-sm="column" fxLayoutGap="20px">
              <mat-form-field floatLabel="always" fxFlex="50%">
                <mat-label>{{'日付範囲チェック（下限）' | translate}}</mat-label>
                <input matInput [ngxMatDatetimePicker]="checkDateRangeLowerPicker"
                  placeholder="{{'日付範囲チェック（下限）' | translate}}" id="≈" formControlName="itemCheckDateRangeLower"
                  readonly>
                <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearCheckDateRangeLower()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="$any(checkDateRangeLowerPicker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #checkDateRangeLowerPicker [showSpinners]="false" [showSeconds]="false"
                  [touchUi]="true" [enableMeridian]="false" [disableMinute]="false" [hideTime]="true"
                  [defaultTime]="[0,0,0]">
                </ngx-mat-datetime-picker>
                <mat-error *ngIf="itemCheckDateRangeLowerControl.invalid">{{'範囲指定に誤りがあります' | translate}}</mat-error>
              </mat-form-field>

              <mat-form-field floatLabel="always" fxFlex="50%">
                <mat-label>{{'日付範囲チェック（上限）' | translate}}</mat-label>
                <input matInput [ngxMatDatetimePicker]="checkDateRangeUpperPicker"
                  placeholder="{{'日付範囲チェック（上限）' | translate}}" id="itemCheckDateRangeUpper"
                  formControlName="itemCheckDateRangeUpper" readonly>
                <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearCheckDateRangeUpper()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="$any(checkDateRangeUpperPicker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #checkDateRangeUpperPicker [showSpinners]="false" [showSeconds]="false"
                  [touchUi]="true" [enableMeridian]="false" [disableMinute]="false" [hideTime]="true"
                  [defaultTime]="[23,59,59]">
                </ngx-mat-datetime-picker>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field floatLabel="always" fxFlex="50%">
                <mat-label>{{'日付期間チェック基準日' | translate}}</mat-label>
                <input matInput [ngxMatDatetimePicker]="checkBaseDatePicker" placeholder="{{'日付期間チェック基準日' | translate}}"
                  id="itemCheckBaseDate" formControlName="itemCheckBaseDate" readonly>
                <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearCheckBaseDate()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="$any(checkBaseDatePicker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #checkBaseDatePicker [showSpinners]="false" [showSeconds]="false"
                  [touchUi]="true" [enableMeridian]="false" [disableMinute]="false" [hideTime]="true"
                  [defaultTime]="[0,0,0]">
                </ngx-mat-datetime-picker>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxFlexFill fxLayoutAlign="start stretch" fxLayout.lt-sm="column" fxLayoutGap="20px">
              <mat-form-field floatLabel="always" fxFlex="50%">
                <mat-label>{{'開始までの期間' | translate}}</mat-label>
                <input matInput placeholder="{{'開始までの期間' | translate}}" id="itemCheckBaseDateToStart"
                  formControlName="itemCheckBaseDateToStart">
              </mat-form-field>
              <mat-form-field floatLabel="always" fxFlex="50%">
                <mat-label>{{'終了までの期間' | translate}}</mat-label>
                <input matInput placeholder="{{'終了までの期間' | translate}}" id="itemCheckBaseDateToEnd"
                  formControlName="itemCheckBaseDateToEnd">
              </mat-form-field>
            </div>

          </div>

          <div *ngIf="questionTypeControl.value === 'datetime'">

            <div fxLayout="row" fxFlexFill fxLayoutAlign="start stretch" fxLayout.lt-sm="column" fxLayoutGap="20px">
              <mat-form-field floatLabel="always" fxFlex="50%">
                <mat-label>{{'日付範囲チェック（下限）' | translate}}</mat-label>
                <input matInput [ngxMatDatetimePicker]="checkDateRangeLowerPicker"
                  placeholder="{{'日付範囲チェック（下限）' | translate}}" id="itemCheckDateRangeLower"
                  formControlName="itemCheckDateRangeLower" readonly>
                <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearCheckDateRangeLower()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="$any(checkDateRangeLowerPicker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #checkDateRangeLowerPicker [showSpinners]="true" [showSeconds]="false"
                  [stepHour]="1" [stepMinute]="1" [stepSecond]="1" [touchUi]="true" [enableMeridian]="false"
                  [disableMinute]="false" [hideTime]="false" [defaultTime]="[0,0,0]">
                </ngx-mat-datetime-picker>
                <mat-error *ngIf="itemCheckDateRangeLowerControl.invalid">{{'範囲指定に誤りがあります' | translate}}</mat-error>
              </mat-form-field>

              <mat-form-field floatLabel="always" fxFlex="50%">
                <mat-label>{{'日付範囲チェック（上限）' | translate}}</mat-label>
                <input matInput [ngxMatDatetimePicker]="checkDateRangeUpperPicker"
                  placeholder="{{'日付範囲チェック（上限）' | translate}}" id="itemCheckDateRangeUpper"
                  formControlName="itemCheckDateRangeUpper" readonly>
                <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearCheckDateRangeUpper()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="$any(checkDateRangeUpperPicker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #checkDateRangeUpperPicker [showSpinners]="true" [showSeconds]="false"
                  [stepHour]="1" [stepMinute]="1" [stepSecond]="1" [touchUi]="true" [enableMeridian]="false"
                  [disableMinute]="false" [hideTime]="false" [defaultTime]="[23,59,59]">
                </ngx-mat-datetime-picker>
              </mat-form-field>
            </div>

          </div>

        </div>

        <div fxLayout="row" fxFlexFill fxLayoutAlign="start stretch" fxLayout.lt-sm="column" fxLayoutGap="20px"
          *ngIf="!!itemCheck11Control.value">
          <mat-form-field floatLabel="always" fxFlex="50%">
            <mat-label>{{'文字数チェック（下限）' | translate}}</mat-label>
            <input type="number" matInput placeholder="{{'文字数チェック（下限）' | translate}}" id="itemCheckColCountLower"
              formControlName="itemCheckColCountLower">
            <mat-error *ngIf="itemCheckColCountLowerControl.invalid">{{'範囲指定に誤りがあります' | translate}}</mat-error>
          </mat-form-field>
          <mat-form-field floatLabel="always" fxFlex="50%">
            <mat-label>{{'文字数チェック（上限）' | translate}}</mat-label>
            <input type="number" matInput placeholder="{{'文字数チェック（上限）' | translate}}" id="itemCheckColCountUpper"
              formControlName="itemCheckColCountUpper">
          </mat-form-field>
        </div>


      </div>
    </form>
  </div>


</div>